import { createSlice } from "@reduxjs/toolkit"

const facebookAdsSlice = createSlice({
  name: "facebookAds",
  initialState: {
    facebookAds: null,
    createFacebookAdLoading: false,
    createFacebookAdError: null,
  },
  reducers: {
    createFacebookAdLoading: (state) => {
      state.createFacebookAdLoading = true
      state.createFacebookAdError = null
    },
    createFacebookAdSuccess: (state, action) => {
      state.facebookAds = action.payload
      state.createFacebookAdLoading = false
      state.createFacebookAdError = null
    },
    createFacebookAdFailure: (state, action) => {
      state.createFacebookAdLoading = false
      state.createFacebookAdError = action.payload
    },
  },
})

export const {
  createFacebookAdLoading,
  createFacebookAdSuccess,
  createFacebookAdFailure,
} = facebookAdsSlice.actions

export default facebookAdsSlice.reducer
